import { Component } from '@angular/core';
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {ActivatedRoute, Router} from "@angular/router";

import merge from 'lodash-es/merge';

import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {TranslateService} from "app/translate";
import {MailService} from "../mail.service";
import {ModalService} from "../../views/modal/base_modal.component";
import {MailerReport} from "./mailer.report";
import {PromptComponent} from "../../views/modal/prompt.component";
import {AlertComponent} from "../../views/modal/alert.component";

function getReportParams(emailKind, mailServises, fields, subscriptions, autologin) {
	return {
		reportName: 'Report Name',
		fields: fields.reduce(
			function (arr, field) {
				if (field.value) {
					arr.push(field.name);
				}
				return arr;
			},
			[]
		),
		mailServises: mailServises.reduce(
			function (arr, mail) {
				if (mail.value) {
					arr.push(mail.name);
				}
				return arr;
			},
			[]
		),
		email: emailKind,
		subscriptions: subscriptions.reduce(
			function (arr, subscription) {
				if (subscription.value) {
					arr.push(subscription.name);
				}
				return arr;
			},
			[]
		),

		autologin: autologin
	};
}

@Component({
	selector: 'app-mailer',
	templateUrl: './mailer.component.html'
})
export class MailerComponent extends BaseComponent {
	refGroupList = [];
	
	
	emailKind = {
		userEmailIsExists:  true,
		userEmailIsConfirm: true
	};
	
	mailServises = [
		{
			name: 'gmail.com',
			value: true
		},
		
		{
			name: 'hotmail',
			value: true
		},
		
		{
			name: 'mail.ru',
			value: true
		},
		
		{
			name: 'rambler',
			value: true
		},
		
		{
			name: 'ya.ru',
			value: true
		},
		
		{
			name: 'yahoo',
			value: true
		},
		
		{
			name: 'other',
			value: true
		}
	];
	
	fields = [
		{
			name     : '_id',
			disabled : true,
			value    : true
		},
		
		{
			name     : 'email',
			disabled : true,
			value    : true
		},
		
		{
			name     : 'domainUrl',
			disabled : true,
			value    : true
		},
		
		{
			name     : 'username',
			disabled : true,
			value    : true
		},
		
		{
			name     : 'unsubscribe_url',
			disabled : true,
			value    : true
		},
		
		{
			name     : 'created',
			disabled : false,
			value    : false
		},
		
		{
			name     : 'dateCreate',
			disabled : false,
			value    : false
		},
		
		{
			name     : 'datePublished',
			disabled : false,
			value    : false
		},
		
		{
			name     : 'location',
			disabled : false,
			value    : false
		},
		
		{
			name     : 'emailService',
			disabled : false,
			value    : false
		},
		
		{
			name: 'referer',
			disabled: false,
			value: false
		},
		
		{
			name: 'autologin',
			disabled: false,
			value: false
		}
	];
	
	
	subscriptions = [
		{
			name: 'notifications',
			value: true
		},
		
		{
			name: 'remind',
			value: true
		},
		
		{
			name: 'discount',
			value: true
		},
		
		{
			name: 'news',
			value: true
		},

		{
			name: 'badge',
			value: true
		}
	];
	
	autologin = {
		expireAt : 14,
		url      : 'pages/id/index/constructor',
	};
	
	tariffs = ['premium', 'premiumplus', 'shop', 'pro'];
	periods = ['24months', '12months', '6months', '3months', 'month'];
	tariffVariants = [];
	_subUrl = '';

	get subUrl() {
		return (this.autologin.url === 'dashBoard/billing/tariffs' ? this._subUrl : '');
	}
	set subUrl(value: string) {
		this._subUrl = value;
	}
	

	addFilterParams = {
		sitesFilter: 'with',
	};
	
	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public translate: TranslateService,
		public modalService: ModalService,
		private router: Router,
		private route: ActivatedRoute,
		public mailService: MailService,
	) {
		super(eventsService, mailService, activatedRoute, filter, translate);

		for(const tariff of this.tariffs) {
			for(const period of this.periods) {
				this.tariffVariants.push(`/${tariff}?period=${period}`);
			}
		}
		
		this.isLoad = false;
	}
	
	
	async ngOnInit() {
		await super.ngOnInit();
		
		const me = this;

		me.refGroupList = await me.filter.getRefGroupFilterList();
	}
	
	
	async showReportList() {
		const me = this;
		
		const w = me.modalService.open(MailerReport, {
			title   : 'Список вызгрузок',
			reports : []
		}, {size: 'hg'});
		
		w.componentInstance.isLoading = true;
		w.componentInstance.reports = await me.mailService.mailer.get(
			{},
			'report'
		).toPromise();
		w.componentInstance.isLoading = false;
	}
	
	
	async addNewReport() {
		const me = this;
		
		const filterParams = me.filter.getCopyFilterParams();
		
		// записать параметры выборки в урл
		const report = getReportParams(
			this.emailKind,
			this.mailServises,
			this.fields,
			this.subscriptions,
			merge({}, this.autologin, {url: `${this.autologin.url}${this.subUrl}`})
		);

		if (report.mailServises.length === 0) {
			this.modalService.open(AlertComponent, {
				title: 'Внимание!',
				message: 'Выберите хоть один из пунктов "Почтовый сервис получателя"'
			});
			
			return ;
		}

		if (report.subscriptions.length === 0) {
			this.modalService.open(AlertComponent, {
				title: 'Внимание!',
				message: 'Выберите хоть один из пунктов "Категория"'
			});
			
			return ;
		}

		if (report.fields.length > 9) {
			this.modalService.open(AlertComponent, {
				title: 'Внимание!',
				message: 'Кол-во dop-полей в "Парметры выборки" должно быть не больше 3-х'
			});
			
			return ;
		}
		
		const modalRef = me.modalService.open(PromptComponent, {
			title    : 'Название выборки',
			question : 'Имя выборки должно содержать только латиницу, цифры и _'
		});
		
		let reportName = '';
		
		modalRef.componentInstance.onChange.subscribe(value => {
			modalRef.componentInstance.errors = [];
			
			if (value.match(/^[a-z0-9-_]{4,}$/i)) {
				reportName = value;
				
				return ;
			}
			
			modalRef.componentInstance.errors.push('Имя должно состоять из латинских букв и цифр (длина больше 4-х символов)');
		});

		// Ждём закрытия формы
		const r = await modalRef.result;

		// TODO Убрать явное использование modalRef.result, заменив на более лучшую версию modalRef.$o
		// Мы должны отличать закрытие формы (по крестику и Close) и применение (Submit)
		if (r === 'cancel') {
			return ;
		}
		
		if ( ! reportName) {
			return ;
		}
		
		report.reportName = reportName;
		filterParams.report = report;
		
		me.mailService.mailer
			.post(
				filterParams,
				'report'
			)
			.subscribe(r => console.log('Ok', r));
	}
	
	
	clearFilter() {
		const
			me  = this,
			url = me.router.url.split('?')[0];
		
		me.router.navigate([url], { relativeTo: me.route, queryParams: {} });
	}
}
